import { z } from 'zod';

/** Standard 5-field cron (minute hour day month weekday). */
export const cronExpressionSchema = z
    .string()
    .trim()
    .regex(/^\S+\s+\S+\s+\S+\s+\S+\s+\S+$/, 'Must be a 5-field cron expression');

export const backupScheduleUpdateSchema = z.object({
    fullCron: cronExpressionSchema,
    incrCron: cronExpressionSchema,
    retentionWeeks: z.coerce.number().int().min(1).max(52),
    pitrEnabled: z.boolean(),
});

export const backupStorageUpdateSchema = z.object({
    type: z.enum(['filesystem', 's3']),
    confirm: z.literal(true),
});
